import { format, getTime, formatDistanceToNow } from 'date-fns';

import {de, enUS, es, fr, nl, ru} from 'date-fns/locale';

import i18n from '../locales/i18n';


const localesMap = {
    en: enUS,
    nl: nl,
    fr: fr,
    es: es,
    de: de,
    ru: ru
};


const getCurrentLocale = () => {

    const lang = i18n.language || 'en';
    return localesMap[lang] || enUS;
};

// ----------------------------------------------------------------------

export function fDate(date, newFormat) {
    const fm = newFormat || 'dd MMM yyyy';

    return date
        ? format(new Date(date), fm, { locale: getCurrentLocale() })
        : '';
}

export function fDateTime(date, newFormat) {
    const fm = newFormat || 'dd MMM yyyy p';

    return date
        ? format(new Date(date), fm, { locale: getCurrentLocale() })
        : '';
}

export function fTimestamp(date) {
    return date ? getTime(new Date(date)) : '';
}

export function fToNow(date) {
    return date
        ? formatDistanceToNow(new Date(date), {
            addSuffix: true,
            locale: getCurrentLocale(),
        })
        : '';
}
